export default __webpack_public_path__ + "static/media/payment-box-icon-04.830e4aaa.png";